export default __webpack_public_path__ + "static/liz-b01d70464d7f4f42de02c83970e91db6.jpg";